export const environment = {
  production: false,
  apiUrl: 'https://kedana-api-764812137437.me-central2.run.app/',
  mqtt: {
    hostname: 'wss.gamaksard.com',
    port: 8081,
    protocol: 'wss' as const,
    path: '/mqtt',
    topics: {
      areaUpdate: 'AreaUpdateTopic',
      zoneUpdate: 'ZoneUpdateTopic',
      blockUpdate: 'BlockUpdateTopic',
      subBlockUpdate: 'SubBlockUpdateTopic',
      subBlockAirUpdate: 'SubBlockAirUpdateTopic'
    }
  }
};
